<template>
<div class="flex items-center justify-center h-screen">
  <h1>{{ statusText }}</h1>
</div>
</template>

<script>
import InjectsSeo from '@/mixins/InjectsSeo'

export default {
  mixins: [InjectsSeo],

  metaInfo() {
    return {
      title: 'Оплата заказа',
      description: 'Страница оплаты заказа',
    }
  },

  computed: {
    statusText() {
      if (this.$route.params.status === 'success') {
        return 'Оплата успешно завершена. Это окно можно закрыть.'
      }

      return 'Произошла ошибка. Вернитесь на предыдущий шаг и попробуйте ещё раз.'
    },
  },
}
</script>
